import React from "react";
import { IconButton, Tooltip, GlobalStyles } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const TableRefreshButton = ({
  onRefresh,
  customSize,
  loading = false,
  tooltip = "Reload",
  size = customSize || 40,
}) => {
  return (
    <>
      {/* Spin animation */}
      <GlobalStyles
        styles={{
          "@keyframes spin": {
            from: { transform: "rotate(0deg)" },
            to: { transform: "rotate(360deg)" },
          },
        }}
      />

      <Tooltip
        title={tooltip}
        arrow
        enterDelay={300}
        leaveDelay={100}
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: "rgba(20, 20, 20, 0.85)",
              backdropFilter: "blur(6px)",
              color: "#fff",
              fontSize: "0.7rem",
              padding: "4px 8px",
              fontWeight: 500,
              borderRadius: "8px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.35)",
              letterSpacing: "0.3px",
            },
          },
          arrow: {
            sx: {
              color: "rgba(20, 20, 20, 0.85)",
            },
          },
        }}
      >
        <IconButton
          onClick={onRefresh}
          disabled={loading}
          sx={{
            width: size,
            height: size,
            borderRadius: "10px",
            border: "1px solid rgba(255,255,255,0.85)",
            backgroundColor: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.2s ease",

            "&:hover": {
              backgroundColor: "rgba(255,255,255,0.18)",
              transform: "scale(1.05)",
            },

            "&.Mui-disabled": {
              opacity: 0.6,
            },
          }}
        >
          <RefreshIcon
            sx={{
              color: "#fff",
              fontSize: 22,
              animation: loading
                ? "spin 0.9s linear infinite"
                : "none",
            }}
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default TableRefreshButton;
